import { PathParams, rest } from 'msw'
import { ChannelsPaymentsResponse } from 'types/channels'
import { EditChannelReq, GetChannelsReq } from 'types/transaction/GetChannelsReq'
import mockChannelsPayments from '../../../__mocks__/Channels/channels_payments.json'
import mockChannels from '../../../__mocks__/Channels/channels.json'

const API_URL = process.env.API_URL ?? 'https://jestjs.io'

const getAllChannelsPayments = rest.get<ChannelsPaymentsResponse>(
  `${API_URL}/api/v2/channel/payment`,
  async (req, res, ctx) => {
    return res(ctx.json(mockChannelsPayments))
  }
)

const getChannels = rest.get<GetChannelsReq>(`${API_URL}/api/v2/channel`, async (req, res, ctx) => {
  return res(ctx.json(mockChannels))
})

export const postChannelSuccess = rest.post(`${API_URL}/pay/v2/channel`, async (req, res, ctx) => {
  return res(
    ctx.json({
      id: 'channel-123',
      redirectUrl: 'https://example.com/channel/channel-123',
    })
  )
})

export const postChannelError = rest.post(`${API_URL}/pay/v2/channel`, async (req, res, ctx) => {
  return res(
    ctx.status(500),
    ctx.json({
      message: 'Internal server error',
      data: {
        message: 'Failed to create channel',
      },
    })
  )
})

export const postChannelFieldError = rest.post(
  `${API_URL}/pay/v2/channel`,
  async (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        message: 'Validation error',
        errorList: [
          {
            parameter: 'walletId',
            message: 'Invalid wallet ID',
          },
        ],
      })
    )
  }
)

const putEditChannel = rest.put<EditChannelReq>(
  `${API_URL}/api/v2/channel`,
  async (req, res, ctx) => {
    return res(ctx.json(mockChannels[0]))
  }
)

export const putEditChannelError = rest.put<EditChannelReq>(
  `${API_URL}/api/v2/channel`,
  async (req, res, ctx) => {
    return res(ctx.status(400), ctx.json({}))
  }
)

export const putUpdateChannelError = rest.put(
  `${API_URL}/api/v2/channel`,
  async (req, res, ctx) => {
    return res(ctx.status(500), ctx.json({ message: 'Internal server error', status: 500 }))
  }
)

const postDeleteChannel = rest.post<{}, PathParams>(
  `${API_URL}/api/v2/channel/:uuid/close`,
  async (req, res, ctx) => {
    return res(ctx.status(204))
  }
)

export const postDeleteChannelError = rest.post<{}, PathParams>(
  `${API_URL}/api/v2/channel/:uuid/close`,
  async (req, res, ctx) => {
    return res(ctx.status(500), ctx.json({ message: 'Failed to delete channel', status: 500 }))
  }
)

export const postDeleteChannelDelayed = rest.post<{}, PathParams>(
  `${API_URL}/api/v2/channel/:uuid/close`,
  async (req, res, ctx) => {
    return res(ctx.delay(500), ctx.status(204))
  }
)

export default [getAllChannelsPayments, getChannels, putEditChannel, postDeleteChannel]
